/**
 * Utility functions for string operations
 */

/**
 * Normalizes text by removing accents/diacritical marks
 * Example: "plátano" -> "platano"
 * 
 * @param {string} text - The text to normalize
 * @returns {string} Text with accents removed
 */
export const removeAccents = (text) => {
  if (!text) return '';
  
  // Decompose the string so that the diacritical marks are separated
  // Then remove the diacritical marks (character class \p{M} matches all marks)
  return text.normalize('NFD').replace(/\p{M}/gu, '');
};

/**
 * Performs an accent-insensitive comparison between two strings
 * 
 * @param {string} str1 - First string to compare
 * @param {string} str2 - Second string to compare
 * @returns {boolean} True if strings match when ignoring accents
 */
export const matchesIgnoringAccents = (str1, str2) => {
  if (typeof str1 !== 'string' || typeof str2 !== 'string') return false;
  
  return removeAccents(str1.toLowerCase()) === removeAccents(str2.toLowerCase());
};

/**
 * Performs an accent-insensitive search (contains)
 * 
 * @param {string} text - The text to search within
 * @param {string} query - The search query
 * @returns {boolean} True if text contains query when ignoring accents
 */
export const containsIgnoringAccents = (text, query) => {
  if (typeof text !== 'string' || typeof query !== 'string' || !query) return false;
  
  const normalizedText = removeAccents(text.toLowerCase());
  const normalizedQuery = removeAccents(query.toLowerCase());
  
  return normalizedText.includes(normalizedQuery);
}; 